export default "/images/fa8543657eacb8994f1270c5ec486e58.png";